import { useSkillContext } from '../../../contexts';
import { ModuleDocument } from '../../module/ModuleTypes';
import { SkillDocument } from '../SkillTypes';
import { SkillWrapper } from './SkillWrapper';
import { EndOfModule } from './upNext/EndOfModule';
import { ModuleComplete } from './upNext/ModuleComplete';
import { UpNext } from './upNext/UpNext';

type SkillUpNextProps = {
  isIntro: boolean;
  isPathway: boolean;
  module: ModuleDocument;
  moduleIsComplete: boolean;
  upNextSkill?: SkillDocument;
  upNextSkillIsCompleted?: boolean;
};

export const SkillUpNext = ({
  isIntro,
  isPathway,
  module,
  moduleIsComplete,
  upNextSkill,
  upNextSkillIsCompleted,
}: SkillUpNextProps): JSX.Element => {
  const { skillRating } = useSkillContext();

  return (
    <SkillWrapper hideContinueButton>
      {moduleIsComplete && <ModuleComplete module={module} />}

      {!moduleIsComplete && upNextSkill && (
        <UpNext
          isIntro={isIntro}
          isPathway={isPathway}
          skillRating={skillRating}
          module={module}
          upNextSkill={upNextSkill}
          upNextSkillIsCompleted={upNextSkillIsCompleted ?? false}
        />
      )}

      {!moduleIsComplete && !upNextSkill && <EndOfModule module={module} />}
    </SkillWrapper>
  );
};
